/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('AdminRepoServiceApi', ($http, ApiErrorService) => {
    return {
        getAdminRepoDescription: getAdminRepoDescription,
        getAdminRepoLibraries: getAdminRepoLibraries,
        getAdminRepoLibraryChildItems: getAdminRepoLibraryChildItems,
        getAdminRepoLibraryItems: getAdminRepoLibraryItems,
        revertRepoItem: revertRepoItem,
        unlockRepoItem: unlockRepoItem,
        cloneRepoItem: cloneRepoItem,
        renameRepoItem: renameRepoItem
    };
    function getAdminRepoDescription(serverControllerId) {
        return $http.get(`api/${serverControllerId}/AdminRepo/repository`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAdminRepoLibraries(serverControllerId) {
        return $http.get(`api/${serverControllerId}/AdminRepo/repository/libraries`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAdminRepoLibraryChildItems(serverControllerId, parentUniqueId) {
        return $http.get(`api/${serverControllerId}/AdminRepo/repository/libraries/items?parentUniqueId=${encodeURIComponent(parentUniqueId)}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAdminRepoLibraryItems(serverControllerId, libraryId) {
        return $http.get(`api/${serverControllerId}/AdminRepo/repository/libraries/${encodeURIComponent(libraryId)}/items`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function revertRepoItem(serverControllerId, itemUniqueId) {
        return $http.post(`api/${serverControllerId}/AdminRepo/repository/libraries/items/${encodeURIComponent(itemUniqueId)}/wip`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function unlockRepoItem(serverControllerId, itemUniqueId) {
        return $http.post(`api/${serverControllerId}/AdminRepo/repository/libraries/items/${encodeURIComponent(itemUniqueId)}/unlock`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function cloneRepoItem(serverControllerId, itemUniqueId) {
        return $http.get(`api/${serverControllerId}/AdminRepo/repository/items/${encodeURIComponent(itemUniqueId)}/clone`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function renameRepoItem(serverControllerId, itemUniqueId) {
        return $http.post(`api/${serverControllerId}/AdminRepo/repository/items/${encodeURIComponent(itemUniqueId)}/rename`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
